import { TokensPage } from './views';

const routes = [
    {
        path: '/tokens/:customer',
        name: 'tokens',
        component: TokensPage,
        meta: {
            title: 'Tokens',
        },
    },
];

export default routes;
